export interface ConfirmCode {
    id: string,
    value: string
}

export const initializedConfirmCode = (): ConfirmCode => {
    return {
        id: '',
        value: ''
    }
}